module.exports = "<h5>Transfers</h5>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/accountprofile/transfers/transfers.html
// module id = 631
// module chunks = 0